import { createFileRoute, redirect } from "@tanstack/react-router";
import { loadBlockPage } from "~/utils/content-fns";
import { BlockRenderer } from "~/components/blocks";
import { seo, seoLinks } from "~/utils/seo";

export const Route = createFileRoute("/register/$slug")({
  loader: async ({ params }) => {
    const page = await loadBlockPage({
      data: { collection: "register", slug: params.slug },
    });

    // Auto-expire: if expires_date is set and in the past, redirect to home
    if (page.expires_date) {
      const expires = new Date(page.expires_date as string);
      if (!isNaN(expires.getTime()) && expires < new Date()) {
        throw redirect({ to: "/" });
      }
    }

    return {
      title: page.title,
      seo_title: page.seo_title,
      seo_description: page.seo_description,
      featured_image: page.featured_image,
      robots: page.robots,
      slug: page.slug,
      blocks: page.blocks || [],
    };
  },
  head: ({ loaderData }) => ({
    meta: loaderData
      ? seo({
          title: loaderData.seo_title || loaderData.title,
          noindex: true,
          url: `/register/${loaderData.slug}`,
        })
      : [],
    links: loaderData ? seoLinks({ url: `/register/${loaderData.slug}` }) : [],
  }),
  component: () => {
    const p = Route.useLoaderData();
    return <BlockRenderer blocks={p.blocks} />;
  },
});
